// REST-обёртка для Web Push (ANX-016).
//
// Эндпоинты в backend'е:
//   GET    /api/v1/push/vapid-key              (public, без auth)
//   GET    /api/v1/me/push/subscriptions       (operator JWT)
//   POST   /api/v1/me/push/subscriptions       (operator JWT, upsert по endpoint)
//   DELETE /api/v1/me/push/subscriptions/:id   (operator JWT)

import type { ApiClient } from './client';

export interface VAPIDKeyResponse {
  public_key: string;
}

export interface PushSubscriptionKeys {
  p256dh: string;
  auth: string;
}

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: PushSubscriptionKeys;
  user_agent?: string;
}

export interface StoredPushSubscription {
  id: string;
  endpoint: string;
  keys: PushSubscriptionKeys;
  user_agent?: string | null;
  created_at: string;
  last_used_at?: string | null;
}

interface ListPushSubscriptionsResponse {
  subscriptions: StoredPushSubscription[];
}

export async function getVAPIDPublicKey(client: ApiClient): Promise<string | null> {
  try {
    const r = await client.request<VAPIDKeyResponse>('/api/v1/push/vapid-key', {
      method: 'GET',
      auth: false,
    });
    return r.public_key;
  } catch {
    // 503 → push не сконфигурирован на сервере. Возвращаем null, UI
    // покажет соответствующее сообщение вместо кнопки "Включить".
    return null;
  }
}

export async function listPushSubscriptions(
  client: ApiClient,
): Promise<StoredPushSubscription[]> {
  const r = await client.request<ListPushSubscriptionsResponse>(
    '/api/v1/me/push/subscriptions',
    { method: 'GET' },
  );
  return r.subscriptions;
}

export async function createPushSubscription(
  client: ApiClient,
  payload: PushSubscriptionPayload,
): Promise<StoredPushSubscription> {
  return client.request<StoredPushSubscription>('/api/v1/me/push/subscriptions', {
    method: 'POST',
    json: payload,
  });
}

export async function deletePushSubscription(
  client: ApiClient,
  id: string,
): Promise<void> {
  await client.request<void>(`/api/v1/me/push/subscriptions/${id}`, {
    method: 'DELETE',
  });
}
